import { BrazeContentCard, getCardPriority } from "../../../services/braze/braze.types";
import { Notification } from "../../../services/notifications/notifications-interface";

export type NotificationFeedEntry =
  | { kind: "backend"; notification: Notification }
  | { kind: "braze"; card: BrazeContentCard };

const feedEntryTimestamp = (entry: NotificationFeedEntry): number => {
  if (entry.kind === "braze") {
    // Cards without an `updated` timestamp sort last in the newest-first order.
    return entry.card.createdAt?.getTime() ?? 0;
  }
  const time = new Date(entry.notification.createdAt).getTime();

  return Number.isNaN(time) ? 0 : time;
};

export const sortFeedEntries = (entries: NotificationFeedEntry[]): NotificationFeedEntry[] =>
  [...entries].sort((a, b) => {
    const aPinned = a.kind === "braze" && a.card.pinned;
    const bPinned = b.kind === "braze" && b.card.pinned;

    if (aPinned !== bPinned) {
      return aPinned ? -1 : 1;
    }

    if (a.kind === "braze" && b.kind === "braze") {
      const priorityA = getCardPriority(a.card);
      const priorityB = getCardPriority(b.card);

      if (priorityA !== priorityB) {
        return priorityA - priorityB;
      }
    }

    return feedEntryTimestamp(b) - feedEntryTimestamp(a);
  });
